import * as React from "react";
import { useState, useRef } from 'react';
import * as ReactDOM from "react-dom";
import "core-js";
import { ajaxSetup } from "jquery";
import { Router, Route, BrowserRouter, IndexRedirect, Switch, Redirect } from 'react-router-dom';
import Utils from './helpers/utils';
import Sidebar from './components/common/container/sidebar';
import CustomModal from './components/common/modal/modal';
import * as rdd from 'react-device-detect';


//Screens
import ALT0101 from "./view/ALT0101/alt0101";
import IHN0101 from "./view/IHN0101/IHN0101";
import IRC0111 from "./view/IRC0111/irc0111";
import IRCO1O1 from "./view/IRC0101/irc0101";
import ICA0111 from "./view/ICA0111/ica0111";
import IAC0101 from "./view/IAC0101/iac0101";
import ICA0101 from "./view/ICA0101/ica0101";
import IRC0111_1 from "./view/IRC0111_1/irc0111_1";
import IRC0111_2 from "./view/IRC0111_2/irc0111_2";
import IAC0100 from "./view/IAC0100/iac0100";

//Path
const URLPath = {
    ALT0101: "/Home/Index",
    IHN0101: "/Product/Search",
    ICA0101: "/Cart/List",
    ICA0111: "/Cart/Confirm",
    IRC0101: "/Billing/Search",
    IRC0111: "/Billing/Details",
    IAC0101: "/Cart/ConfirmFacilityInfo",
    IRC0111_1: "/Billing/Delete/Confirmation",
    IRC0111_2: "/Billing/Delete/Details",
    IAC0100: "/Cart/SelectFacilityInfo"
}
export default function App() {
    const [isSessionExpired, setIsSessionExpired] = useState(false);

    const detectCustomMobileDevice = Boolean(rdd.getUA.match(
        /Android|X11; Linux x86_64|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i
    ));
    if (rdd.isMobile || detectCustomMobileDevice) {
        rdd.isMobile = true;
        rdd.isBrowser = false;
    }
    ajaxSetup({
        cache: false,
        statusCode: {
            401: () => setIsSessionExpired(true)
        }
    });

    var mybutton = document.getElementById("backtoTopBtn");
    if (rdd.isMobile) {
        window.onscroll = function () { scrollFunction() };
        document.body.classList.add("tablet-font-size");
        $("#left-sidebar").addClass("sidebar-hide-left");
        $("#main-content-wrapper").addClass("expanded-full");
    }

    return (
        <div className="wrapper">
            {/* <Sidebar URLPath={URLPath} /> */}
            <CustomModal
                title="セッション期限切れ"
                size="md"
                hideCloseButton={true}
                isShow={isSessionExpired}
                handlerClose={() => window.location.reload()}
                handlerSaveChange={() => window.location.reload()}
                saveChangeLabel="OK"
            >
                セッションが期限切れとなりました。セッションを更新するにはページを再読み込みしてください。
            </CustomModal>
            <Switch>
                <Route exact path="/">
                    <Redirect to={URLPath.IHN0101} />
                </Route>
                <Route path={URLPath.ALT0101} component={(props) => <ALT0101 URLPath={URLPath} />} />
                <Route path={URLPath.IHN0101} component={IHN0101} />
                <Route path={URLPath.IRC0111} component={(props) => <IRC0111 URLPath={URLPath} />} />
                <Route path={URLPath.IRC0101} component={(props) => <IRCO1O1 URLPath={URLPath} />} />
                <Route path={URLPath.ICA0111} component={(props) => <ICA0111 URLPath={URLPath} />} />
                <Route path={URLPath.IAC0100} component={(props) => <IAC0100 URLPath={URLPath} />} />
                <Route path={URLPath.IAC0101} component={(props) => <IAC0101 URLPath={URLPath} />} />
                <Route path={URLPath.ICA0101} component={(props) => <ICA0101 URLPath={URLPath} />} />
                <Route path={URLPath.IRC0111_1} component={(props) => <IRC0111_1 URLPath={URLPath} />} />
                <Route path={URLPath.IRC0111_2} component={(props) => <IRC0111_2 URLPath={URLPath} />} />
            </Switch>
        </div>

    );
    function scrollFunction() {
        if ($(document).scrollTop() > 30) {
            mybutton.style.display = "block";
        } else {
            mybutton.style.display = "none";
            $("#backtoTopBtnDiv").removeClass("bottomSpacing");
        }

        if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
            $("#backtoTopBtnDiv").addClass("bottomSpacing");
        }
    }
}

ReactDOM.render(

    <BrowserRouter basename={window.domainDir}>
        <App URLPath={URLPath} />
    </BrowserRouter>,
    document.getElementById("app")
);


// WEBPACK FOOTER //
// ./app.jsx